// src/App.js
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CustomCursor from "./components/CustomCursor";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsappButton";
import SeoMeta from "./components/SeoMeta";

function App() {
  useEffect(() => {
    // Add smooth scroll behavior
    document.documentElement.style.scrollBehavior = "smooth";
    
    // Prevent default right-click
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    
    // Prevent image drag
    document.addEventListener('dragstart', (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SeoMeta />
        <CustomCursor />
        <ScrollToTop />
        <WhatsAppButton />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;